'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Grid = require('../Grid/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _GridCell = require('../Grid/GridCell');

var _GridCell2 = _interopRequireDefault(_GridCell);

var _DatePickerHeaderControl = require('./DatePickerHeaderControl');

var _DatePickerHeaderControl2 = _interopRequireDefault(_DatePickerHeaderControl);

var _DatePickerViewMonth = require('./DatePickerViewMonth');

var _DatePickerViewMonth2 = _interopRequireDefault(_DatePickerViewMonth);

var _utils = require('./utils');

require('./DatePicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePickerSelection = function (_Component) {
  _inherits(DatePickerSelection, _Component);

  function DatePickerSelection(props) {
    _classCallCheck(this, DatePickerSelection);

    var _this = _possibleConstructorReturn(this, (DatePickerSelection.__proto__ || Object.getPrototypeOf(DatePickerSelection)).call(this, props));

    _this.handleDaySelect = _this.handleDaySelect.bind(_this);

    var _this$props = _this.props,
        calendarOpenDate = _this$props.calendarOpenDate,
        rangeSelect = _this$props.rangeSelect,
        selectedDate = _this$props.selectedDate;

    var _orderDates = (0, _utils.orderDates)(_this.props.selectedStartDate, _this.props.selectedEndDate),
        _orderDates2 = _slicedToArray(_orderDates, 2),
        selectedStartDate = _orderDates2[0],
        selectedEndDate = _orderDates2[1];

    var activeStartDate = (0, _utils.dateOrNow)((rangeSelect ? selectedStartDate : selectedDate) || calendarOpenDate);

    var activeEndDate = rangeSelect && selectedEndDate ? (0, _utils.isSameMonth)(selectedEndDate, selectedStartDate) ? (0, _utils.addMonths)(selectedEndDate, 1) : selectedEndDate : (0, _utils.addMonths)(activeStartDate, 1);

    _this.state = {
      activeStartDate: activeStartDate,
      activeEndDate: activeEndDate
    };
    return _this;
  }

  _createClass(DatePickerSelection, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          selectedDate = _props.selectedDate,
          selectedStartDate = _props.selectedStartDate,
          selectedEndDate = _props.selectedEndDate,
          rangeSelect = _props.rangeSelect,
          view = _props.view;


      if (!rangeSelect && selectedDate && !prevProps.selectedDate) {
        this.setState({ activeStartDate: selectedDate });
      }

      if (rangeSelect && selectedStartDate !== prevProps.selectedStartDate) {
        this.setState({ activeStartDate: selectedStartDate });
      }

      if (rangeSelect && view === 'double' && selectedEndDate !== prevProps.selectedEndDate) {
        if ((0, _utils.isSameMonth)(selectedStartDate, selectedEndDate)) {
          this.setState({ activeEndDate: (0, _utils.addMonths)(selectedEndDate, 1) });
        } else {
          this.setState({ activeEndDate: selectedEndDate });
        }
      }
    }
  }, {
    key: 'handleActiveStartDateChange',
    value: function handleActiveStartDateChange(direction) {
      this.setState(function (state) {
        return {
          activeStartDate: (0, _utils.addMonths)(state.activeStartDate, direction)
        };
      });
    }
  }, {
    key: 'handleActiveEndDateChange',
    value: function handleActiveEndDateChange(direction) {
      this.setState(function (state) {
        return {
          activeEndDate: (0, _utils.addMonths)(state.activeEndDate, direction)
        };
      });
    }
  }, {
    key: 'handleDaySelect',
    value: function handleDaySelect(date) {
      var _props2 = this.props,
          onSelect = _props2.onSelect,
          rangeSelect = _props2.rangeSelect,
          selectedStartDate = _props2.selectedStartDate,
          selectedEndDate = _props2.selectedEndDate;


      if (!rangeSelect) {
        return onSelect({ date: new Date(date) });
      }

      if (!selectedStartDate || (0, _utils.isBeforeDay)(date, selectedStartDate)) {
        return onSelect({
          dateStart: new Date(date),
          dateEnd: selectedEndDate && new Date(selectedEndDate)
        });
      }

      if (!selectedEndDate || (0, _utils.isAfterDay)(date, selectedEndDate)) {
        return onSelect({
          dateStart: new Date(selectedStartDate),
          dateEnd: new Date(date)
        });
      }

      return onSelect({
        dateStart: new Date(date),
        dateEnd: undefined
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          activeEndDate = _state.activeEndDate,
          activeStartDate = _state.activeStartDate;
      var _props3 = this.props,
          earliestSelectableDate = _props3.earliestSelectableDate,
          latestSelectableDate = _props3.latestSelectableDate,
          rangeSelect = _props3.rangeSelect,
          selectedDate = _props3.selectedDate,
          selectedEndDate = _props3.selectedEndDate,
          selectedStartDate = _props3.selectedStartDate,
          view = _props3.view;

      var _orderDates3 = (0, _utils.orderDates)(selectedStartDate, selectedEndDate),
          _orderDates4 = _slicedToArray(_orderDates3, 2),
          startDate = _orderDates4[0],
          endDate = _orderDates4[1];

      var _orderDates5 = (0, _utils.orderDates)(earliestSelectableDate, latestSelectableDate),
          _orderDates6 = _slicedToArray(_orderDates5, 2),
          earliestDate = _orderDates6[0],
          latestDate = _orderDates6[1];

      var isDoubleView = view === 'double';

      var activeEndDateOrNextMonth = activeEndDate || (0, _utils.addMonths)(activeStartDate, 1);

      return _react2.default.createElement(
        _Grid2.default,
        { responsive: false, shrink: true },
        _react2.default.createElement(
          _GridCell2.default,
          null,
          _react2.default.createElement(_DatePickerHeaderControl2.default, {
            date: activeStartDate,
            earliestSelectableDate: earliestDate,
            latestSelectableDate: isDoubleView ? (0, _utils.addMonths)(activeEndDate, -1) : latestDate,
            onNext: function onNext() {
              return _this2.handleActiveStartDateChange(1);
            },
            onPrevious: function onPrevious() {
              return _this2.handleActiveStartDateChange(-1);
            } }),
          _react2.default.createElement(_DatePickerViewMonth2.default, {
            date: activeStartDate,
            earliestSelectableDate: earliestDate,
            latestSelectableDate: latestDate,
            onSelect: this.handleDaySelect,
            rangeSelect: rangeSelect,
            selectedDate: !rangeSelect ? selectedDate : undefined,
            selectedEndDate: rangeSelect ? endDate : undefined,
            selectedStartDate: rangeSelect ? startDate : undefined })
        ),
        isDoubleView && _react2.default.createElement(
          _GridCell2.default,
          { hiddenUntil: 'small' },
          _react2.default.createElement(_DatePickerHeaderControl2.default, {
            date: activeEndDateOrNextMonth,
            earliestSelectableDate: (0, _utils.addMonths)(activeStartDate, 1),
            latestSelectableDate: latestDate,
            onNext: function onNext() {
              return _this2.handleActiveEndDateChange(1);
            },
            onPrevious: function onPrevious() {
              return _this2.handleActiveEndDateChange(-1);
            } }),
          _react2.default.createElement(_DatePickerViewMonth2.default, {
            date: activeEndDateOrNextMonth,
            earliestSelectableDate: earliestDate,
            latestSelectableDate: latestDate,
            onSelect: this.handleDaySelect,
            rangeSelect: rangeSelect,
            selectedDate: !rangeSelect ? selectedDate : undefined,
            selectedEndDate: rangeSelect ? endDate : undefined,
            selectedStartDate: rangeSelect ? startDate : undefined })
        )
      );
    }
  }]);

  return DatePickerSelection;
}(_react.Component);

DatePickerSelection.propTypes = {
  /**
   * The date that should be shown to the user when the picker opens.
   * When a selected date or range is given, that supersedes this
   * property. Defaults to 'today'.
   */
  calendarOpenDate: _propTypes2.default.instanceOf(Date),
  /** A lower limit to the earliest date that can be selected */
  earliestSelectableDate: _propTypes2.default.instanceOf(Date),
  /** An upper limit to the latest date that can be selected */
  latestSelectableDate: _propTypes2.default.instanceOf(Date),
  /** Callback for when a date, range with endDate and startDate, or a range
   * out of rangeSelections has been selected */
  onSelect: _propTypes2.default.func.isRequired,
  /** Whether a date range can be selected */
  rangeSelect: _propTypes2.default.bool,
  /** Predefined date ranges offered for selection. label will be shown and
   * range is passed to onSelect when clicked. */
  // eslint-disable-next-line react/no-unused-prop-types
  rangeSelections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    range: _propTypes2.default.string.isRequired
  })),
  /** A single date that appears selected */
  selectedDate: _propTypes2.default.instanceOf(Date),
  /** The date selected at the end of the range */
  selectedEndDate: _propTypes2.default.instanceOf(Date),
  /** The selected range, specified as it's label */
  // eslint-disable-next-line react/no-unused-prop-types
  selectedRange: _propTypes2.default.string,
  /** The date selected at the start of the range */
  selectedStartDate: _propTypes2.default.instanceOf(Date),
  /** Configuration for a single date picker view or two pickers side by side */
  view: _propTypes2.default.oneOf(['single', 'double'])
};
DatePickerSelection.defaultProps = {
  view: 'single',
  rangeSelect: false
};
exports.default = DatePickerSelection;